class CompressionLevelSideModal extends HTMLElement {
  constructor() {
    super();
    this.buttonOpen = document.querySelectorAll('.compression-level-wrapper .popup-trigger');
    this.buttonClose = this.querySelector('.close');
    this.onKeyDown = this.handleKeyDown.bind(this);
    this.onClick = this.handleOnClick.bind(this);

    if (this.buttonOpen) {
      // There can be more than 1 when there's a Bundle
      this.buttonOpen.forEach(btn => {
        btn.addEventListener('click', this.open.bind(this))
      })
    }

    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', this.close.bind(this));
    }
  }

  open(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if(!this.isOpen()) {
      $s.showOverlay();
      this.classList.add('open');
      setTimeout(()=>{
        $s.trapFocus(this)
        document.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('click', this.onClick);
      }, 100);
    }
  }

  close() {
    $s.removeTrapFocus();
    $s.hideOverlay();
    this.classList.remove('open');
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('click', this.onClick);
  }

  isOpen() {
    return this.classList.contains('open');
  }

  handleKeyDown(e) {
    if (e.which == 27) { //Exit
      if(this.isOpen()){
        e.preventDefault();
        this.close();
        return false;
      }
    }
  }

  handleOnClick(e) {
    if(!this.contains(e.target)) {
      this.close();
    }
  }
}
customElements.define('compression-level-side-modal', CompressionLevelSideModal);